import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;

const getParticipantesPO = async (municipio = null) => {
  const endpoint = "/api/financiero/participantes";
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: municipio ? { municipio } : {}
  });
  return response.data;
};

const getMunicipiosPO = async (departamento = null) => {
  const endpoint = "/api/financiero/municipios";
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: departamento ? { departamento } : {}
  });
  return response.data;
};

const getDepartamentosPO = async () => {
  const endpoint = "/api/financiero/departamentos";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const getProyectosPO = async () => {
  const endpoint = "/api/financiero/proyectos";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

// Relación proyecto → municipios (ac_proyectos_municipios). Sin parámetro trae
// todas las relaciones, para filtrar en el cliente por el proyecto de cada fila.
const getMunicipiosPorProyectoPO = async (proyecto = null) => {
  const endpoint = "/api/financiero/proyectos/municipios";
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: proyecto ? { proyecto } : {}
  });
  return response.data;
};

const getOrganizacionesPO = async () => {
  const endpoint = "/api/financiero/organizaciones";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

// Participantes vinculados al proyecto (pa_participante_proyecto), con teléfono y vereda.
const getParticipantesPorProyectoPO = async (proyecto) => {
  const endpoint = "/api/financiero/participantes";
  const response = await axios.get(`${baseUrl}${endpoint}`, { params: { proyecto } });
  return response.data;
};

// Organizaciones del proyecto (org_organizaciones).
const getOrganizacionesPorProyectoPO = async (proyecto) => {
  const endpoint = "/api/financiero/organizaciones";
  const response = await axios.get(`${baseUrl}${endpoint}`, { params: { proyecto } });
  return response.data;
};

const getResponsablesPO = async () => {
  const endpoint = "/api/financiero/responsables";
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

export {
  getParticipantesPO,
  getMunicipiosPO,
  getDepartamentosPO,
  getProyectosPO,
  getMunicipiosPorProyectoPO,
  getOrganizacionesPO,
  getParticipantesPorProyectoPO,
  getOrganizacionesPorProyectoPO,
  getResponsablesPO
};
